<div>
    <ng-content/>
</div>
